export const getShareUrl = (baseShareUrl, params) => {
  const formattedParams = new URLSearchParams(params);
  return baseShareUrl + formattedParams;
};

export default getShareUrl;
